import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@mui/material';
import RuleSummaryComponent from './RuleSummaryComponent';
import Timeline from '@mui/icons-material/Timeline';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'hooks/apollo';
import { FINANCIAL_PRODUCT_QUERY } from 'features/financialProducts/edit/queries';

export const RuleSidebarSummaryContainer = ({ productId }) => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const { data } = useQuery(FINANCIAL_PRODUCT_QUERY, {
    variables: { productId },
    skip: !productId
  });

  const summaryTab = <RuleSummaryComponent productId={productId} productSummary={data?.financialProduct?.leasingFinancialProduct} />;

  const handleChange = (_, value) => {
    setTabValue(value);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} variant='fullWidth' indicatorColor='secondary' textColor='secondary'>
        <Tab icon={<Timeline />} label={t('FinancialProduct.Details.Rules.RightSidebar.SummaryTabTitle')} />
      </Tabs>
      {tabValue === 0 && summaryTab}
    </>
  );
};

RuleSidebarSummaryContainer.propTypes = {
  productId: PropTypes.number.isRequired
};
